<template>
<div>
<div v-if="!clinic">
	<h1>Laddar...</h1>
	<div class="panel panel-clinic">
		<div class="panel-body" style="height:330px;">
			<div class="list-loader-outer clinic-form">
	            <transition name="loader-fade">
	                <div class="list-loader">
	                    <div class="loader"></div>
	                </div>
	            </transition>
	        </div>
		</div>
	</div>
</div>
<div v-else>

		<div class="modal fade" tabindex="-1" role="dialog" id="errorModal">
	    <div class="modal-dialog" role="document">
	        <div class="modal-content">

	            <div class="modal-header">
		            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
		            	<span aria-hidden="true">&times;</span>
		            </button>
		            <h4 class="modal-title">Systemfel</h4>
	        	</div>

		        <div class="modal-body">
		        	<p><b>{{ updateError.message }}</b></p>
		        	<p>Kopiera informationen nedan och skicka till support@bechwebb.se</p>
		        	<pre>{{ updateError.details }}</pre>
		        </div>

		        <div class="modal-footer">
		        	<button type="button" class="btn btn-info" data-dismiss="modal">Stäng</button>
		        </div>

	        </div><!-- /.modal-content -->
	    </div><!-- /.modal-dialog -->
	</div>

	<h1>

		<a href="/prospects/" v-if="clinic.statusList == 'Prospect' || clinic.statusList == 'Avslutat prospect' || clinic.statusList == 'Inaktivt prospect'">Prospects</a>

		<a href="/clinics/" v-else>Partners</a>

		/ #{{ clinic.id }} {{ clinic.name_person }}

	</h1>

	<div id="fixedCollapseMenu">
		<div class="left" v-html="panelTitle"></div>
		<div class="right">#{{ clinic.id }} {{ clinic.name_person }}</div>
	</div>

	<div id="selectTabsMenu" v-bind:class="{ folded: !folded }">

		<div class="select-tabs-head" v-on:click="folded = !folded">
			Visa panel
			<div class="arrow-left"></div>
		</div>

		<div class="select-tabs-body">

			<div class="row">
				<input type="radio" v-bind:value="null" v-model="panel_settings.setting" id="selectTabsAll">
				<label for="selectTabsAll">Alla</label>
			</div>

			<div class="row">
				<input type="radio" value="grunduppgifter" v-model="panel_settings.setting" id="selectTabsBasic">
				<label for="selectTabsBasic">Search</label>
			</div>

			<div class="row">
				<input type="radio" value="intervju" v-model="panel_settings.setting" id="selectTabsInterview">
				<label for="selectTabsInterview">Bearbetning</label>
			</div>

			<div class="row">
				<input type="radio" value="anslutning" v-model="panel_settings.setting" id="selectTabsConnection">
				<label for="selectTabsConnection">Anslutning</label>
			</div>

			<div class="row">
				<input type="radio" value="uppstart" v-model="panel_settings.setting" id="selectTabsStart">
				<label for="selectTabsStart">Uppstartsmöte</label>
			</div>

		</div>

	</div>

	<form-summary :clinic="clinic" :meta="meta" :product_areas="product_areas" :errors="errors" :users="users"></form-summary>

	<form-review-updates :clinic="clinic" :meta="meta" :errors="errors"></form-review-updates>

	<form-contact-prospect :clinic="clinic" :meta="meta" :users="users" :product_areas="product_areas" :errors="errors" v-show="showPanel(['intervju'])"></form-contact-prospect>

	<form-log :clinic="clinic" :meta="meta" :errors="errors" :users="users" v-show="showPanel(['grunduppgifter', 'intervju', 'anslutning', 'uppstart'])"></form-log>

	<form-contact :clinic="clinic" :meta="meta" :users="users" :product_areas="product_areas" :errors="errors" v-show="showPanel(['grunduppgifter', 'intervju', 'anslutning'])"></form-contact>

	<form-address :clinic="clinic" :meta="meta" :errors="errors" v-show="showPanel(['anslutning', 'uppstart'])"></form-address>
	
	<form-portals :clinic="clinic" :meta="meta" :errors="errors" v-show="showPanel(['intervju'])"></form-portals>

	<form-booking :clinic="clinic" :meta="meta" :errors="errors" v-show="showPanel(['uppstart'])"></form-booking>

	<form-presentation :clinic="clinic" :meta="meta" :errors="errors" v-show="showPanel([''])"></form-presentation>

	<form-practitioners :clinic="clinic" :meta="meta" :errors="errors" v-show="showPanel([''])"></form-practitioners>

	<form-education :clinic="clinic" :meta="meta" :errors="errors" v-show="showPanel(['intervju'])"></form-education>

	<form-supplementary-internal :clinic="clinic" :meta="meta" :errors="errors" v-show="showPanel(['intervju'])"></form-supplementary-internal>

	<form-supplementary-external :clinic="clinic" :meta="meta" :errors="errors" v-show="showPanel(['intervju'])"></form-supplementary-external>

	<form-supplementary-pt :clinic="clinic" :meta="meta" :errors="errors" v-show="showPanel(['intervju'])"></form-supplementary-pt>

	<form-prospect :clinic="clinic" :meta="meta" :errors="errors" :payments="payments" v-show="showPanel(['anslutning'])"></form-prospect>

	<form-contract :clinic="clinic" :meta="meta" :errors="errors" :users="users" :payments="payments" v-show="showPanel(['anslutning', 'uppstart'])"></form-contract>

	<form-connection-internal :clinic="clinic" :meta="meta" :errors="errors" :users="users" v-show="showPanel(['uppstart'])"></form-connection-internal>

	<form-connection-external :clinic="clinic" :meta="meta" :errors="errors" :users="users" v-show="showPanel(['uppstart'])"></form-connection-external>

  <form-connection-pt :clinic="clinic" :meta="meta" :errors="errors" :users="users" v-show="showPanel(['uppstart'])"></form-connection-pt>

	<form-payments :clinic="clinic" :meta="meta" :errors="errors" :payments="payments" :price-groups="payments.periods" v-show="showPanel(['anslutning'])"></form-payments>

	<form-mp :clinic="clinic" :meta="meta" :errors="errors" :login-log="loginLog" v-show="showPanel([''])"></form-mp>

	<form-punch :clinic="clinic" :meta="meta" :errors="errors" v-show="showPanel([''])"></form-punch>

	<form-bonus :clinic="clinic" :errors="errors" :payments="payments" v-show="showPanel([''])"></form-bonus>

	<form-reports :clinic="clinic" :meta="meta" :errors="errors" v-show="showPanel([''])"></form-reports>

	<form-gdpr :clinic="clinic" :meta="meta" :errors="errors" v-show="showPanel([''])"></form-gdpr>
</div>
<!--
<div class="row" style="margin-bottom: 25px;">
	<div class="col-md-5">
		<a href="/clinics/">Tillbaka</a>
	</div>
	<div class="col-md-45">
		<button class="btn btn-danger pull-right" v-on:click="trash()" v-if="trashable">Radera massör</button>
	</div>
</div>
-->

<div class="backlink">
	<a href="/clinics/">Tillbaka</a>
    <button class="btn btn-danger pull-right" v-on:click="trash()" v-if="isTrashable">Radera massör</button>
</div>

</div>
</template>

<script>

import formReviewUpdates from './form-review-updates.vue'
import formAddress from './form-address.vue'
import formSummary from './form-summary.vue'
import formContactProspect from './form-contact-prospect.vue'
import formContact from './form-contact.vue'
import formLog from './form-log.vue'
import formPortals from './form-portals.vue'
import formBooking from './form-booking.vue'
import formEducation from './form-education.vue'
import formSupplementaryInternal from './form-supplementary-internal.vue'
import formSupplementaryExternal from './form-supplementary-external.vue'
import formSupplementaryPt from './form-supplementary-pt.vue'
import formProspect from './form-prospect.vue'
import formContract from './form-contract.vue'
import formConnectionInternal from './form-connection-internal.vue'
import formConnectionExternal from './form-connection-external.vue'
import formConnectionPt from './form-connection-pt.vue'
import formPayments from './form-payments.vue'
import formMp from './form-mp.vue'
import formPunch from './form-punch.vue'
import formBonus from './form-bonus.vue'
import formReports from './form-reports.vue'
import formPresentation from './form-presentation.vue'
import formGdpr from './form-gdpr.vue'
import FormPractitioners from './form-practitioners.vue'

export default {

    components: {
        formReviewUpdates,
        formAddress,
        formSummary,
        formContactProspect,
        formContact,
        formLog,
        formPortals,
        formBooking,
        formEducation,
        formSupplementaryInternal,
        formSupplementaryExternal,
        formSupplementaryPt,
        formProspect,
        formContract,
        formConnectionInternal,
        formConnectionExternal,
        formConnectionPt,
        formPayments,
        formMp,
        formPunch,
        formBonus,
        formReports,
        formPresentation,
        FormPractitioners,
        formGdpr

    },

    props: {

        clinicId: {
            required: true
        }
    },

    data () {
        return {

            clinic: null,
            meta: [],
            payments: {},
            isTrashable: false,
            loginLog: [],
            users: [],
            product_areas: [],
            panel_settings: null,

            errors: {},

            panelTitle: null,
            folded: false,

            updateError: {}

        }
    },

    created () {
        const self = this

        self.fetch()

        bus.$on('refresh-data', function () {
            self.fetch()
        })

        window.addEventListener('error', function (e) {
            console.log('error in event listner')
            console.log(e)

            self.updateError = {
		        	message: 'Något gick fel på sidan.',
		        	details: {
			        	time: moment().format('YYYY-MM-DD HH:mm:ss'),
			        	message: e.message,
			        	error: {
			        		message: e.error.message,
			        		stack: e.error.stack
			        	}
			        }
		        }

		        $('#errorModal').modal('show')
        })
    },

    watch: {

        clinic: {
		      	handler (val, oldVal) {
		      		console.log('clinic watcher triggered')

		      		if (!oldVal) {
		      			this.$nextTick(function () {
		      				this.jQueryListeners()
			        	})
		      		}
		      		if (oldVal) {
		      			console.log('clinic watcher triggered, update clinic data')
		      			this.update()
		      		}
		      	},
		      	deep: true
		    },
		    panel_settings: {
		      	handler (val, oldVal) {
		      		if (oldVal) {
		      			console.log('panel_settings watcher triggered, update panel_settings data')
		      			this.updatePanelSetting()
		      		}
		      	},
		      	deep: true
		    }

    },

    methods: {

        showPanel (panels) {
            if (!this.panel_settings.setting || panels.indexOf(this.panel_settings.setting) !== -1) {
                return true
            }
            return false
        },

        fetch () {
            const self = this

            console.log('fetching clinic')

            self.$http.post(
                '/clinics/' + self.clinicId,
                { clinic_id: self.clinicId }
            )
                .then((response) => {
			        console.log('fetch clinic response')
			        console.log(response.data)

			        self.clinic = response.data.clinic
			        self.meta = response.data.meta
			        self.payments = {
			        	periods: response.data.payments.periods,
			        	durations: response.data.payments.durations,
			        	lastAccountedYearAndMonth: response.data.payments.lastAccountedYearAndMonth
			        }
                    self.isTrashable = response.data.isTrashable
			        self.loginLog = response.data.loginLog
			        self.users = response.data.users
			        self.product_areas = response.data.product_areas
			       	self.errors = response.body.errors
			       	self.panel_settings = response.body.panel_settings
                }, (response) => {
		        	console.log(JSON.stringify(response))
		   		})
		   	},

		   	update: _.debounce(function () {
			   		const self = this

			   		console.log('running update clinic')

			   		self.$http.post('/clinics/update', self.clinic).then((response) => {
			   			console.log('update clinic response')
			   			console.log(response.body)

				        if (response.body.errors) {
				            self.errors = response.body.errors
				        } else {
				            self.errors = {}
				        }

                if (response.body.refresh) {
                    bus.$emit('refresh-data')
                }
				    }, (response) => {
				        console.log(response)

				        self.updateError = {
				        	message: 'Något gick fel när informationen skulle sparas.',
				        	details: {
					        	time: moment().format('YYYY-MM-DD HH:mm:ss'),
					        	status: response.status,
					        	statusText: response.statusText,
					        	url: response.url
					        }
				        }

				        $('#errorModal').modal('show')
				    })
		   		}, 500

		   	),

		   	trash () {
	    		const self = this
	    		if (!confirm('All information om massören kommer att raderas från systemet. Är du säker?')) {
	    			return
	    		}

	    		if (!confirm('Är du supersäker?')) {
	    			return
	    		}

	    		self.$http.delete('/clinics/' + self.clinic.id + '/trash').then((response) => {
			    	console.log('trash clinic response')
			    	console.log(response.data)

			    	bus.$emit('notify', 'Massören har raderats från systemet.')
			    	window.location.href = '/clinics'
            }, (response) => {
                console.log(JSON.stringify(response))
            })
	    	},

		   	updatePanelSetting () {
		   		const self = this

		   		self.$http.post('/clinics/updatePanelSetting', self.panel_settings).then((response) => {
		   			console.log('updatePanelSetting response')
		   			console.log(response.body)
			    }, (response) => {
			        console.log(JSON.stringify(response))
			    })
		   	},

		   	jQueryListeners () {
		   		const self = this

		   		_.forEach(self.panel_settings, function (value, panel) {
			   		if ($('#' + panel).hasClass('panel-collapse') && value == 1) {
	                    $('#' + panel).collapse('show')
	                }
	            })

	            if (window.location.hash) {
	                setTimeout(function () {
	                    const $target = $(window.location.hash)
	                    if ($target.length) {
	                        if ($target.hasClass('panel-collapse')) {
	                            $target.collapse('show')
	                        }
	                        $('html, body').animate({ scrollTop: $target.offset().top - 100 }, 500)
	                    }
	                }, 400)
	            }

		   		$('body').on('shown.bs.collapse', '.panel .panel-collapse', function () {
				    const active = $(this).attr('id')
			    	self.panel_settings[active] = 1
            })
		   		$('body').on('hidden.bs.collapse', '.panel .panel-collapse', function () {
				    const active = $(this).attr('id')
			    	self.panel_settings[active] = null
            })

		    	/* Show static label for panbel-collapse */
            $(window).scroll(function () {
                let matchingPanel = null

				    /* Clinic panels static */

				    if ($(window).scrollTop() > 150) {
				        if (!$('#fixedCollapseMenu').hasClass('visible')) {
				            $('#fixedCollapseMenu').addClass('visible')
				        }
				    }

				    if ($(window).scrollTop() < 150) {
				        if ($('#fixedCollapseMenu').hasClass('visible')) {
				            $('#fixedCollapseMenu').removeClass('visible')
				        }
				    }

				    $('.panel-collapse').each(function (index) {
				        if ($(this).hasClass('in')) {
				            const paneltop = $(this).offset().top
				            const panelbottom = paneltop + $(this).height()

				            if ($(window).scrollTop() > paneltop - 43 && $(window).scrollTop() < panelbottom) {
				            	matchingPanel = $(this).parent().find('.panel-title').html()
				            }
				        }
				    })

				    if (self.panelTitle != matchingPanel) {
				    	self.panelTitle = matchingPanel
				    }
            })
		   	}

    }

}

</script>
